import { c as _c } from "react/compiler-runtime";
import clsx from "classnames";
import { GridSlot, GridSlotSize } from "common/types/graphql";
import { PropsWithChildren, forwardRef, ForwardedRef, DragEvent } from "react";
export interface ImmutableGridSlotProps {
  /** True if the grid slot should be rendered as a placeholder, false otherwise. */
  asPlaceholder?: boolean;

  /** indicates whether the grid slot is being dropped (mouse over) */
  isOver?: boolean;

  /** The size of the grid slot. */
  size?: GridSlotSize;

  /** The type of the grid slot. */
  type?: GridSlot;

  /** Function to be called when after a drop event. */
  handleDrop?: (ev: DragEvent<HTMLDivElement>) => void;

  /** Function to be called when a draggable element is over the top of this. */
  handleDragOver?: (ev: DragEvent<HTMLDivElement>) => void;

  /** Function to be called when the thing in the grid has started to be dragged */
  handleDragStart?: (ev: DragEvent<HTMLDivElement>) => void;
}

/** A read-only grid slot. */
export const ImmutableGridSlot = forwardRef(function ImmutableGridSlot(t0, ref) {
  "use memo";

  const $ = _c(22);
  const {
    size: t1,
    asPlaceholder: t2,
    isOver: t3,
    children,
    handleDrop,
    handleDragOver,
    handleDragStart
  } = t0;
  const size = t1 === undefined ? GridSlotSize.Base : t1;
  const asPlaceholder = t2 === undefined ? false : t2;
  const isOver = t3 === undefined ? false : t3;
  const t4 = size === GridSlotSize.Base;
  const t5 = size === GridSlotSize.BaseWide;
  const t6 = size === GridSlotSize.Lg;
  const t7 = size === GridSlotSize.Xl;
  const t8 = size === GridSlotSize.NearFullByTwo;
  const t9 = size === GridSlotSize.NearFullByThree;
  const t10 = size === GridSlotSize.NearFullByFour;
  const t11 = size === GridSlotSize.DisappearingThumbnail;
  const t12 = asPlaceholder && !isOver;
  const t13 = asPlaceholder && isOver;
  const t14 = !asPlaceholder;
  let t15;
  if ($[0] !== asPlaceholder || $[1] !== isOver || $[2] !== t10 || $[3] !== t11 || $[4] !== t12 || $[5] !== t13 || $[6] !== t14 || $[7] !== t4 || $[8] !== t5 || $[9] !== t6 || $[10] !== t7 || $[11] !== t8 || $[12] !== t9) {
    t15 = clsx("group relative col-span-full flex overflow-hidden focus-within:overflow-visible", {
      "sm:col-span-3": t4,
      "sm:col-span-6": t5,
      "row-span-2 sm:col-span-6": t6,
      "row-span-4 sm:col-span-6": t7,
      "row-span-2 sm:col-span-9": t8,
      "row-span-3 sm:col-span-9 2xl:col-span-7": t9,
      "row-span-4 sm:col-span-9 2xl:col-span-7": t10,
      "row-span-1 sm:col-span-3 2xl:col-span-5": t11,
      "m-2.5 min-h-28 bg-blue-100 outline-offset-8 outline-dashed": asPlaceholder,
      "outline-2 outline-offset-4 outline-gray-700 outline-dashed": isOver,
      "outline-1 outline-blue-500": t12,
      "outline-2 outline-gray-700": t13,
      "border-t pt-4": t14
    });
    $[0] = asPlaceholder;
    $[1] = isOver;
    $[2] = t10;
    $[3] = t11;
    $[4] = t12;
    $[5] = t13;
    $[6] = t14;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
    $[13] = t15;
  } else {
    t15 = $[13];
  }
  const t16 = asPlaceholder ? "false" : "true";
  let t17;
  if ($[14] !== children || $[15] !== handleDragOver || $[16] !== handleDragStart || $[17] !== handleDrop || $[18] !== ref || $[19] !== t15 || $[20] !== t16) {
    t17 = <div className={t15} ref={ref} data-testid="ImmutableGridSlot" onDrop={handleDrop} onDragOver={handleDragOver} onDragStart={handleDragStart} draggable={t16}>{children}</div>;
    $[14] = children;
    $[15] = handleDragOver;
    $[16] = handleDragStart;
    $[17] = handleDrop;
    $[18] = ref;
    $[19] = t15;
    $[20] = t16;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  return t17;
});